<template>
  <VisnetHubForm
    title="Edit VisnetHub"
    :visnet-hub="visnetHub"
    :project-code="projectCode"
    :main-error="mainError"
    :inputs-errors="inputsErrors"
    @submit="submit"
  />
</template>

<script>
import { mapState } from 'vuex';
import VisnetHubForm from './visnet-hub-form';

export default {
  name: 'VisnetHubEdit',
  components: { VisnetHubForm },
  props: ['projectCode', 'substationCode', 'externalVisnetHubId'],
  data() {
    return {
      mainError: null,
      inputsErrors: []
    };
  },
  computed: {
    ...mapState({
      visnetHub: state => state.substationVisnetHub.visnetHub,
      substation: state => state.substationVisnetHub.visnetHub.substation
    })
  },
  mounted() {
    this.$store.dispatch('substationVisnetHub/fetchData', {
      projectCode: this.projectCode,
      substationCode: this.substationCode,
      externalVisnetHubId: this.externalVisnetHubId
    });
  },
  destroyed() {
    this.$store.commit('substationVisnetHub/resetStore');
  },
  methods: {
    async submit(data) {
      await this.$store.dispatch('substationDevices/editVisnet', {
        projectCode: this.projectCode,
        substationCode: this.substationCode,
        externalVisnetHubId: this.externalVisnetHubId,
        data
      });

      this.$store.dispatch('substationDevices/fetchSubstationDeviceData', {
        projectCode: this.projectCode,
        substationCode: this.substationCode
      });

      this.$router.push({
        name: 'substationDevices',
        params: {
          projectCode: this.projectCode,
          substationCode: this.substationCode
        }
      });
    }
  }
};
</script>
